import Api from "./Api";
import axios from "axios";
import { BASEURL } from "@/config/index";
import { createQueryString } from "./ApiHelper";

export default {
  GetActiveDistributors(payload) {
    return Api().post("/active-list/ms_distributors", payload);
  },
  GetDistributorContractByMovieId(payload) {
    return Api().get(
      `/api/admin/get-distributorcontract-bymovieid/${payload.movie_id}`
    );
  },
  // Distributor Share types
  GetActiveDistributorShareTypes(payload) {
    return Api().post("/active-list/distributor_share_type", payload);
  },
  AddDistributorShareType(payload) {
    return Api().post(`/api/admin/distributorsharetype`, payload);
  },
  GetDistributorShareType(payload) {
    return Api().get(
      `/api/admin/distributorsharetype?limit=${payload.limit}&currentPage=${payload.currentPage}&columnName=${payload.columnName}&orderBy=${payload.orderBy}`
    );
  },
  GetDistributorShareTypeById(payload) {
    return Api().get(`/api/admin/distributorsharetype/${payload.dst_id}`);
  },
  updateDistributorShareType(payload) {
    return Api().put(
      `/api/admin/distributorsharetype/${payload.dst_id}`,
      payload
    );
  },
  // Distributor Contract
  AddDistributorContract(payload) {
    return Api().post(`/api/admin/distributorcontract`, payload);
  },
  GetDistributorContract(payload) {
    const query = createQueryString(payload);
    return Api().get(`/api/admin/distributorcontract${query}`);
  },
  GetDistributorContractById(payload) {
    return Api().get(`/api/admin/distributorcontract/${payload.dc_id}`);
  },
  updateDistributorContract(payload) {
    return Api().put(
      `/api/admin/distributorcontract/${payload.dc_id}`,
      payload
    );
  },

  /**
   * Distributor Share
   */
  GetDistributorContractDates(payload) {
    return Api().post(`/api/admin/distributorsharecontractdates`, payload);
  },
  GetDistributorShares(payload) {
    // let query = ''
    // let length = Object.keys(payload).length
    // if (length > 0) {
    //     query = '?'
    //     Object.keys(payload).map((x, index) => {
    //         if (payload[x]) {
    //             query += index === length - 1 ? `${x}=${payload[x]}` : `${x}=${payload[x]}&`
    //         }
    //     })
    // }
    return Api().post(`/api/admin/distributorshare`, payload);
  },
  GetDistributorMoviesById(payload) {
    return Api().get(
      `/api/admin/distributormovies/${payload.distributor_id}/${payload.country_id}`
    );
  },
  GetDistributorMoviesWithFormat(payload) {
    return Api().get(
      `/api/admin/distributormovieswithformat/${payload.movie_id}`
    );
  },
  GetDistributorActiveMasterMovie() {
    return Api().get(`/api/admin/getactivemastermovie`);
  },
  /**
   * Distributor Share End
   */
  /**
   *
   */
  GetDistributorDeductionsMovies(payload) {
    return Api().post(`/api/admin/getdistributordeductionsmovies`, payload);
  },
  GetDistributorDeductionsCinemas(payload) {
    return Api().get(`/api/admin/distributordeductionscinemas/${payload}`);
  },
  AddDistributorDeductions(payload) {
    return Api().post(`/api/admin/distributordeductions`, payload);
  },
  EditDistributorDeductions(payload) {
    return Api().put(`/api/admin/distributordeductions`, payload);
  },
  GetAllDistributorDeductions(payload) {
    return Api().post(`/api/admin/viewdistributordeductions`, payload);
  },
  GetSingleDistributionDeduction(payload) {
    return Api().post(`/api/admin/viewsingledistributordeductions`, payload);
  },
  GetSingleDistributionDeductionById(payload) {
    return Api().post(
      `/api/admin/viewsingledistributordeductionsbyid`,
      payload
    );
  },

  //Contract
  AddMasterContract(payload) {
    return Api().post(`/api/admin/ms_contract`, payload);
  },
  UpdateMasterContract(payload) {
    return Api().put(`/api/admin/ms_contract`, payload);
  },
  GetSingleContractDetails(payload) {
    return Api().get(`/api/admin/ms_contract/${payload.contract_id}`);
  },
  //Master Week Wise Contract
  GetAllWeekWiseContractList(payload) {
    if (!payload) {
      return Api().get(`/api/admin/weekwise_contracts`);
    } else {
      return Api().get(
        `/api/admin/weekwise_contracts?limit=${payload.limit}&currentPage=${payload.currentPage}&columnName=${payload.columnName}&orderBy=${payload.orderBy}`
      );
    }
  },
  AddMasterContractByWeekWise(payload) {
    return Api().post(`/api/admin/weekwise_contracts`, payload);
  },
  UpdateMasterContractByWeekWise(payload) {
    return Api().put(`/api/admin/weekwise_contracts`, payload);
  },
  GetSingleContractByWeekWiseDetails(payload) {
    return Api().post(`/api/admin/single_weekwise_contracts`, payload);
  }
};



// WEBPACK FOOTER //
// ./src/services/DistributorService.js